import FileSaver from 'file-saver';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { push } from 'connected-react-router';

import { COVERAGE_TABS } from '../../../constants';

export const createCoverageOperations = ({
  actions,
  selectors,
  operations,
  filterOperations,
}) => ({
  getCoverage: () => (dispatch, getState) => {
    const params = selectors.getParams(getState());
    return dispatch(actions.getCoverage(params));
  },

  getCoverageCSV: (filePrefix = '') => (dispatch, getState) => {
    const params = selectors.getParams(getState());

    return dispatch(actions.getCoverageCSV(params))
      .then((response) => {
        const fileData = [response.data];
        FileSaver.saveAs(
          new Blob(fileData),
          `${filePrefix ? `${filePrefix}-` : ''}coverage-${new Date().getTime()}.csv`,
        );
      }).catch((error) => (
        dispatch(notificationActions.notifyDanger(
          error.message, 'We\'ve experienced an issue while downloading CSV file.', true,
        ))
      ));
  },

  changeSorting: (payload) => (dispatch) => {
    dispatch(actions.changeSorting(payload));
    return dispatch(operations.getCoverage());
  },

  cleanup: () => (dispatch) => (
    dispatch(actions.cleanup())
  ),

  initialize: (meta) => (dispatch) => (
    Promise.all([
      dispatch(actions.initialized()),
      dispatch(filterOperations.initialize(meta)),
    ]).then(() => (
      dispatch(operations.getCoverage())
    )).catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message, 'We\'ve experienced an issue loading coverage.', true,
      ));
    })
  ),
});

export const createCoverageContainerOperations = ({
  deviceOperations,
  browserOperations,
  osOperations,
}) => ({
  getCoverage: ({ tabName } = {}) => (dispatch) => {
    switch (tabName) {
      case COVERAGE_TABS.browsers.key:
        return dispatch(browserOperations.getCoverage());
      case COVERAGE_TABS.os.key:
        return dispatch(osOperations.getCoverage());
      case COVERAGE_TABS.devices.key:
      default:
        return dispatch(deviceOperations.getCoverage());
    }
  },

  getCoverageCSV: ({ tabName } = {}) => (dispatch) => {
    switch (tabName) {
      case COVERAGE_TABS.browsers.key:
        return dispatch(browserOperations.getCoverageCSV('browser'));
      case COVERAGE_TABS.os.key:
        return dispatch(osOperations.getCoverageCSV('os'));
      case COVERAGE_TABS.devices.key:
      default:
        return dispatch(deviceOperations.getCoverageCSV('device'));
    }
  },
  redirect: push,
});
